<template>
  <!-- START: Scanner default view -->
  <div class="d-flex flex-column text-center mt-5">
    <h1 class="mb-3" v-if="hasCameraPermission">{{ header }}</h1>
    <p class="wc-barcode-instruction" v-if="hasCameraPermission">{{ message }}</p>
    <h1 class="mb-3" v-if="!hasCameraPermission">
      <button
        class="border-primary btn text-primary rounded"
        @click="reload()"
        :aria-label="$t('allowCamera')"
      >
        {{ $t('allow') }}
      </button>
    </h1>
    <p class="wc-barcode-instruction" v-if="!hasCameraPermission">
      {{ $t('pleaseAllowCamera') }}
    </p>
  </div>
  <!-- END: Scanner default view -->
</template>
<script>
export default {
  name: 'ScanDefaultView',
  props: {
    header: {
      type: String,
      default: 'Scanner',
    },
    message: {
      default: 'Center barcode in the frame and hold it steady.',
    },
    hasCameraPermission: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    // Reload when there is no camera permission provided
    reload() {
      window.location.reload();
    },
  },
};
</script>
<style lang="scss" scoped>
.wc-barcode-instruction {
  white-space: pre-wrap;
  font-weight: 400;
}
</style>
